export default __webpack_public_path__ + "static/our-culture-9e5e8079905838ce74a0c2599178a1a9.jpg";